import { Exercise } from '@playground/models/exercise.model';
import { TestsResults } from '@playground/models/tests.model';
import { Runners } from '@playground/models/runners.model';
import { Actions, ActionsTypes } from './actions';

export type PlaygroundState = {
  exercise: Exercise | null;
  runner: RunnerState;
};

export type RunnerState = {
  lives: number;
  code: string;
  showSolution: boolean;
  currentTabIndex: number;
  testsStatus: TestsResults['status'];
  testsResult: TestsResults['result'];
  mode: 'embed' | 'external';
  runner: Runners;
};

export const playgroundInitState = (): PlaygroundState => {
  return {
    exercise: null,
    runner: {
      currentTabIndex: 0,
      lives: 3,
      code: '',
      showSolution: false,
      mode: 'external',
      testsStatus: 'init',
      testsResult: 'init',
      runner: null,
    },
  };
};

export const playgroundReducer = (state: PlaygroundState, action: Actions): PlaygroundState => {
  const { type, payload } = action;

  switch (type) {
    case ActionsTypes.SetExercise: {
      return {
        ...state,
        exercise: payload,
      };
    }
    case ActionsTypes.SetRunner: {
      return {
        ...state,
        runner: {
          ...state.runner,
          ...payload,
        },
      };
    }
    default:
      return state;
  }
};
